export default __webpack_public_path__ + "static/media/image1.74383680.png";